import { useIntl } from 'react-intl';
import { addMethod, object, string } from 'yup';
import { buildMessageCallback } from '../../../validation/utilities';
import messages from './messages';

const isValidPhoneNumber = 'isValidPhoneNumber';
const IS_VALID_PHONE_NUMBER = 'is-valid-phone-number';

addMethod(string, isValidPhoneNumber, function validatePhoneNumber(messageCallback) {
  return this.test(IS_VALID_PHONE_NUMBER, messageCallback, (value) => {
    if (!value) {
      return false;
    }
    const digitsOnlyNumber = value.replace(/\D+/g, '');
    return digitsOnlyNumber && digitsOnlyNumber.length >= 10 && digitsOnlyNumber.length <= 15;
  });
});

export const useContactSalesValidationSchema = () => {
  const intl = useIntl();
  const phoneError = intl.formatMessage(messages.phoneError);

  return object().shape({
    name: string().required(buildMessageCallback(messages.nameRequired)),
    phoneNumber: string()
      .required(buildMessageCallback(messages.phoneNumberRequired))
      .isValidPhoneNumber(buildMessageCallback(messages.phoneNumberValidationError))
      .test({
        name: phoneError,
        message: buildMessageCallback(messages.phoneNumberValidationCharError),
        test: (value) => !value || /^[\d()+\s-]+$/.test(value),
      }),
    email: string().required(buildMessageCallback(messages.emailRequired)).email(buildMessageCallback(messages.emailValidationError)),
  });
};
